/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { MediaAssetDto } from '../models';
// @ts-ignore
import type { MediaRejectionDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Draft versions only. Material of a version in force or a retired one stays, because an attempt has to be reproducible with the picture the employee actually saw. The file leaves the store only when no other version still shows it — a newer version may have taken it over.
         * @summary Remove a picture or a film
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedia: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteMedia', 'assetId', assetId)
            const localVarPath = `/api/v1/media/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Answers with a redirect to a link that works for a few minutes, so this address goes straight into an img or video element. The link names neither the file nor the question, and the store behind it is private: without a session here there is no way to the bytes, and a link copied out of the browser stops working within minutes. Questions are exam material; a picture at a public, guessable address would leak the bank no matter how well the rest is guarded.
         * @summary Read a picture or a film
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedia: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getMedia', 'assetId', assetId)
            const localVarPath = `/api/v1/media/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Same rules as for a version, and the same draft-only condition — the one the answer belongs to. The answer is named by its id, which stays the same through a correction that names it; see NewAnswerOption.id.
         * @summary Attach a picture or a film to one answer
         * @param {string} answerId 
         * @param {File} file 
         * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAnswerMedia: async (answerId: string, file: File, locale?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'answerId' is not null or undefined
            assertParamExists('uploadAnswerMedia', 'answerId', answerId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAnswerMedia', 'file', file)
            const localVarPath = `/api/v1/answers/{answerId}/media`
                .replace(`{${"answerId"}}`, encodeURIComponent(String(answerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (locale !== undefined) { 
                localVarFormParams.append('locale', locale as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Draft versions only. What the file is gets read from its content, never from its name: pictures as JPEG, PNG or WebP up to 5 MB and 4000 px along the longer side; films as MP4 with H.264 picture and AAC sound, up to 20 MB, 90 seconds and 720p, with the index at the front (\"fast start\") so that playing starts before the download ends. A refused file comes back with the reason and the numbers behind it — say in the interface what is wrong with the file, not that the upload failed. Checking the size before sending saves the author a long wait for a refusal.
         * @summary Attach a picture or a film to a version
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {File} file 
         * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadQuestionMedia: async (questionId: string, versionId: string, file: File, locale?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('uploadQuestionMedia', 'questionId', questionId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('uploadQuestionMedia', 'versionId', versionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadQuestionMedia', 'file', file)
            const localVarPath = `/api/v1/questions/{questionId}/versions/{versionId}/media`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (locale !== undefined) { 
                localVarFormParams.append('locale', locale as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Draft versions only. Material of a version in force or a retired one stays, because an attempt has to be reproducible with the picture the employee actually saw. The file leaves the store only when no other version still shows it — a newer version may have taken it over.
         * @summary Remove a picture or a film
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMedia(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMedia(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.deleteMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Answers with a redirect to a link that works for a few minutes, so this address goes straight into an img or video element. The link names neither the file nor the question, and the store behind it is private: without a session here there is no way to the bytes, and a link copied out of the browser stops working within minutes. Questions are exam material; a picture at a public, guessable address would leak the bank no matter how well the rest is guarded.
         * @summary Read a picture or a film
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedia(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedia(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.getMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Same rules as for a version, and the same draft-only condition — the one the answer belongs to. The answer is named by its id, which stays the same through a correction that names it; see NewAnswerOption.id.
         * @summary Attach a picture or a film to one answer
         * @param {string} answerId 
         * @param {File} file 
         * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAnswerMedia(answerId: string, file: File, locale?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaAssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAnswerMedia(answerId, file, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.uploadAnswerMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Draft versions only. What the file is gets read from its content, never from its name: pictures as JPEG, PNG or WebP up to 5 MB and 4000 px along the longer side; films as MP4 with H.264 picture and AAC sound, up to 20 MB, 90 seconds and 720p, with the index at the front (\"fast start\") so that playing starts before the download ends. A refused file comes back with the reason and the numbers behind it — say in the interface what is wrong with the file, not that the upload failed. Checking the size before sending saves the author a long wait for a refusal.
         * @summary Attach a picture or a film to a version
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {File} file 
         * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadQuestionMedia(questionId: string, versionId: string, file: File, locale?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaAssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadQuestionMedia(questionId, versionId, file, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.uploadQuestionMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * Draft versions only. Material of a version in force or a retired one stays, because an attempt has to be reproducible with the picture the employee actually saw. The file leaves the store only when no other version still shows it — a newer version may have taken it over.
         * @summary Remove a picture or a film
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedia(assetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMedia(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Answers with a redirect to a link that works for a few minutes, so this address goes straight into an img or video element. The link names neither the file nor the question, and the store behind it is private: without a session here there is no way to the bytes, and a link copied out of the browser stops working within minutes. Questions are exam material; a picture at a public, guessable address would leak the bank no matter how well the rest is guarded.
         * @summary Read a picture or a film
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedia(assetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMedia(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Same rules as for a version, and the same draft-only condition — the one the answer belongs to. The answer is named by its id, which stays the same through a correction that names it; see NewAnswerOption.id.
         * @summary Attach a picture or a film to one answer
         * @param {string} answerId 
         * @param {File} file 
         * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAnswerMedia(answerId: string, file: File, locale?: string, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetDto> {
            return localVarFp.uploadAnswerMedia(answerId, file, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Draft versions only. What the file is gets read from its content, never from its name: pictures as JPEG, PNG or WebP up to 5 MB and 4000 px along the longer side; films as MP4 with H.264 picture and AAC sound, up to 20 MB, 90 seconds and 720p, with the index at the front (\"fast start\") so that playing starts before the download ends. A refused file comes back with the reason and the numbers behind it — say in the interface what is wrong with the file, not that the upload failed. Checking the size before sending saves the author a long wait for a refusal.
         * @summary Attach a picture or a film to a version
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {File} file 
         * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadQuestionMedia(questionId: string, versionId: string, file: File, locale?: string, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetDto> {
            return localVarFp.uploadQuestionMedia(questionId, versionId, file, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - interface
 * @export
 * @interface MediaApi
 */
export interface MediaApiInterface {
    /**
     * Draft versions only. Material of a version in force or a retired one stays, because an attempt has to be reproducible with the picture the employee actually saw. The file leaves the store only when no other version still shows it — a newer version may have taken it over.
     * @summary Remove a picture or a film
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApiInterface
     */
    deleteMedia(assetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Answers with a redirect to a link that works for a few minutes, so this address goes straight into an img or video element. The link names neither the file nor the question, and the store behind it is private: without a session here there is no way to the bytes, and a link copied out of the browser stops working within minutes. Questions are exam material; a picture at a public, guessable address would leak the bank no matter how well the rest is guarded.
     * @summary Read a picture or a film
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApiInterface
     */
    getMedia(assetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Same rules as for a version, and the same draft-only condition — the one the answer belongs to. The answer is named by its id, which stays the same through a correction that names it; see NewAnswerOption.id.
     * @summary Attach a picture or a film to one answer
     * @param {string} answerId 
     * @param {File} file 
     * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApiInterface
     */
    uploadAnswerMedia(answerId: string, file: File, locale?: string, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetDto>;

    /**
     * Draft versions only. What the file is gets read from its content, never from its name: pictures as JPEG, PNG or WebP up to 5 MB and 4000 px along the longer side; films as MP4 with H.264 picture and AAC sound, up to 20 MB, 90 seconds and 720p, with the index at the front (\"fast start\") so that playing starts before the download ends. A refused file comes back with the reason and the numbers behind it — say in the interface what is wrong with the file, not that the upload failed. Checking the size before sending saves the author a long wait for a refusal.
     * @summary Attach a picture or a film to a version
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {File} file 
     * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApiInterface
     */
    uploadQuestionMedia(questionId: string, versionId: string, file: File, locale?: string, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetDto>;

}

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI implements MediaApiInterface {
    /**
     * Draft versions only. Material of a version in force or a retired one stays, because an attempt has to be reproducible with the picture the employee actually saw. The file leaves the store only when no other version still shows it — a newer version may have taken it over.
     * @summary Remove a picture or a film
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public deleteMedia(assetId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).deleteMedia(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Answers with a redirect to a link that works for a few minutes, so this address goes straight into an img or video element. The link names neither the file nor the question, and the store behind it is private: without a session here there is no way to the bytes, and a link copied out of the browser stops working within minutes. Questions are exam material; a picture at a public, guessable address would leak the bank no matter how well the rest is guarded.
     * @summary Read a picture or a film
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getMedia(assetId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).getMedia(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Same rules as for a version, and the same draft-only condition — the one the answer belongs to. The answer is named by its id, which stays the same through a correction that names it; see NewAnswerOption.id.
     * @summary Attach a picture or a film to one answer
     * @param {string} answerId 
     * @param {File} file 
     * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public uploadAnswerMedia(answerId: string, file: File, locale?: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).uploadAnswerMedia(answerId, file, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Draft versions only. What the file is gets read from its content, never from its name: pictures as JPEG, PNG or WebP up to 5 MB and 4000 px along the longer side; films as MP4 with H.264 picture and AAC sound, up to 20 MB, 90 seconds and 720p, with the index at the front (\"fast start\") so that playing starts before the download ends. A refused file comes back with the reason and the numbers behind it — say in the interface what is wrong with the file, not that the upload failed. Checking the size before sending saves the author a long wait for a refusal.
     * @summary Attach a picture or a film to a version
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {File} file 
     * @param {string} [locale] The language the material is for, such as pl or pt-BR. Leave it out for material that serves every language — the usual case for a picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public uploadQuestionMedia(questionId: string, versionId: string, file: File, locale?: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).uploadQuestionMedia(questionId, versionId, file, locale, options).then((request) => request(this.axios, this.basePath));
    }
}

